import { setURL } from '@/api/apiUtil'

export default {
  // 取得車辨設備列表 棄用，改用設備列表API
  // getHtDevice: {
  //   url: (communityId) =>
  //     setURL('/ht/devices/:communityId', { communityId }),
  //   method: 'get'
  // },
  // 根據社區編號，停車場id(code)取得車輛列表
  getVehicleList: {
    url: setURL('/ht/list'),
    method: 'get'
  },
  // 新增車輛
  addVehicle: {
    url: setURL('/ht/add'),
    method: 'post'
  },
  // 根據車輛編號刪除車輛
  deleteVehicle: {
    url: (vehicleId) => {
      // return setURL('/ht/del/:vehicleId', { vehicleId })
      return setURL('/ht/del/:vehicleId', { vehicleId })
    },
    method: 'delete'
  },
  // 根據車輛編號取得車輛資訊
  getVehicleInfo: {
    url: (vehicleId) =>
      setURL('/ht/:vehicleId', { vehicleId }),
    method: 'get'
  },
  // 根據車輛編號修改車輛資訊
  updateVehicleInfo: {
    url: (vehicleId) =>
      setURL('/ht/:vehicleId', { vehicleId }),
    method: 'put'
  },
  // 車輛名單管理匯入
  importVehicleList: {
    url: (communityId) =>
      setURL('/ht/import/:communityId', { communityId }),
    method: 'post'
  },
  // 車輛進出紀錄
  entryRecord: {
    url: setURL('/ht/entryRecord'),
    method: 'get'
  },
}